<div class="container text-center mt-3"><h1>Please wait while we log you out...</h1></div>
